import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import { otsBaseQuery } from '../store/ots-api';

export type CompliancePdfDocument = {
  program: 'ep9' | 'ep10';
  id: string;
  tenantCode?: string;
};
/** Fetch authenticated PDF bytes without storing Blobs or credentials in Redux or frame URLs. */
export const loadCompliancePdf = async (
  document: CompliancePdfDocument,
  api: BaseQueryApi,
  signal: AbortSignal
): Promise<Blob> => {
  const result = await otsBaseQuery(
    {
      url: `/compliance/rrc/${document.program}/${encodeURIComponent(
        document.id
      )}/pdf`,
      params: { tenantCode: document.tenantCode },
      headers: { Accept: 'application/pdf' },
      signal,
      responseHandler: async (response) => {
        if (response.ok) return response.blob();
        const message = await response.text();
        try {
          return JSON.parse(message);
        } catch {
          return message;
        }
      },
    },
    { ...api, signal },
    {}
  );
  if (result.error) throw result.error;
  const blob = result.data as Blob;
  if (!(blob instanceof Blob) || (await blob.slice(0, 5).text()) !== '%PDF-')
    throw new Error('The service did not return a PDF document.');
  return new Blob([blob], { type: 'application/pdf' });
};
